(() => {
  // A single credential-free request per page reads Shopify's GBP -> EUR rate.
  // The active rate uses the same shop-currency base. No cart or country changes.
  let euroRatePromise;

  function getEuroRate(url) {
    if (!euroRatePromise) {
      euroRatePromise = fetch(url, {
        credentials: 'omit',
        signal: AbortSignal.timeout(8000),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Currency rate unavailable');
          return response.text();
        })
        .then((html) => {
          const match = html.match(/Shopify\.currency\s*=\s*(\{[^;]+\})\s*;/);
          if (!match) throw new Error('Currency rate missing');
          const currency = JSON.parse(match[1]);
          const rate = Number(currency.rate);
          if (currency.active !== 'EUR' || !Number.isFinite(rate) || rate <= 0) {
            throw new Error('Invalid EUR rate');
          }
          return rate;
        })
        .catch((error) => {
          euroRatePromise = undefined;
          throw error;
        });
    }
    return euroRatePromise;
  }

  class FreeShippingProgress extends HTMLElement {
    async connectedCallback() {
      if (!this.hasAttribute('data-convert-eur')) return;
      try {
        const currency = this.dataset.currency;
        const active = window.Shopify?.currency;
        const activeRate = Number(active?.rate);
        const subtotal = Number(this.dataset.subtotal);
        if (active?.active !== currency || !Number.isFinite(activeRate) || activeRate <= 0 ||
            !Number.isFinite(subtotal) || subtotal < 0) return;

        const euroRate = await getEuroRate(this.dataset.rateUrl);
        if (!this.isConnected) return;
        // Round up to the next currency subunit, never unlocking prematurely.
        const threshold = Math.ceil(30000 * activeRate / euroRate);
        const remaining = Math.max(0, threshold - subtotal);
        const progress = Math.min(100, subtotal / threshold * 100);
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2,
        }).format(remaining / 100);
        const message = remaining > 0
          ? `You’re ${amount} away from free shipping`
          : 'You’ve unlocked free shipping!';

        this.querySelector('.free-shipping-progress__message').textContent = message;
        const track = this.querySelector('.free-shipping-progress__track');
        track.setAttribute('aria-valuenow', progress.toFixed(2));
        track.setAttribute('aria-valuetext', message);
        this.querySelector('.free-shipping-progress__fill').style.width = `${progress}%`;
        this.hidden = false;
      } catch {
        // Keep hidden if Shopify cannot supply a verified conversion rate.
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('free-shipping-progress')) {
    customElements.define('free-shipping-progress', FreeShippingProgress);
  }
})();
